export enum RemoteParamsMode {
  standBy = 'standBy',
  loading = 'loading',
  loaded = 'loaded',
}

export type RemoteParamsState<T> =
  | { mode: RemoteParamsMode.standBy }
  | { mode: RemoteParamsMode.loading }
  | { mode: RemoteParamsMode.loaded; data: T };
